import React from "react";

const Logo = ({ size = 88 }) => {
  return (
    <div className="flex items-center gap-4 select-none">
      <img
        src="https://customer-assets-gfyr7b9c.emergentagent.net/job_web-launch-512/artifacts/o355uapb_Logo%20Transparent.png"
        alt="Nyle Apparel Symbol"
        style={{ height: size, width: "auto" }}
        className="object-contain"
      />
      <img
        src="https://customer-assets-gfyr7b9c.emergentagent.net/job_web-launch-512/artifacts/aad1g293_Name%20Transparent.png"
        alt="Nyle Apparel"
        style={{ height: size * 1.75, width: "auto" }}
        className="object-contain"
      />
    </div>
  );
};

export default Logo;
